import { getAllTiposByProyecto } from 'api/estructuraCostes/tiposJitApi'
import { ViewerContext } from 'context/ViewerContext'
import { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { getBulkPropertiesAsync } from 'utils/getPropertiesViewer'
import { expandTipos } from 'utils/handleTipos'
import { viewer } from 'utils/launchViewer'

export const useGetDataBoq = () => {
  const { idProject } = useParams()

  const { externalIdsMapping } = useContext(ViewerContext)

  const getAllDbIdsByTipo = async (isCreateBoq = false) => {
    // *: Sacar todos los tipobimlinkproyectos del proyecto
    const bimlinks = await getAllTiposByProyecto(idProject, { visible: true })

    // * Por cada externalId que hay dentro del tipo, crear un objeto con las mismas propiedades que dicho tipo, modificando el array del tipoExternalId por el string de dicho externalId
    const expandedArray = expandTipos(bimlinks)

    // * Asignar dbId al los tipos
    const bimlinksWithDbId = expandedArray.map(bimlink => ({
      ...bimlink,
      dbId: externalIdsMapping[bimlink.tipoExternalId],
    }))

    // * Para cada bimlink sacar su child
    const bimlinksWithChild = await Promise.all(
      bimlinksWithDbId.map(bimlink =>
        getBulkPropertiesAsync(viewer, [bimlink.dbId], ['child'])
      )
    )

    if (isCreateBoq) {
      return bimlinksWithChild
        .flat()
        .map(singleBimLink =>
          singleBimLink.properties.map(property => ({
            dbId: property.displayValue,
            tipobimlink: bimlinksWithDbId.find(
              bd => bd.dbId === singleBimLink.dbId
            ),
          }))
        )
        .flat()
    } else {
      return bimlinksWithChild
        .flat()
        .map(singleBimLink =>
          singleBimLink.properties.map(property => property.displayValue)
        )
        .flat()
    }
  }

  return { getAllDbIdsByTipo }
}
